import React from 'react'
import Hero from '../components/ui/Hero'
import Navbar from '../components/ui/Navbar'
import VisualFeatures from '../components/ui/VisualFeatures'
import Features from '../components/ui/Features'
import CTA from '../components/ui/CTA'
import HappyClients from '../components/ui/HappyClients'
import Pricing from '../components/ui/Pricing'
import FAQs from '../components/ui/FAQs'
import Footer from '../components/ui/Footer'

function index() {
  return (
    <div className='bg-gray-900'>
      <Navbar />
      <Hero />
      <VisualFeatures />
      <Features />
      <HappyClients />
      <Pricing />
      <FAQs />
      <Footer />
    </div>
  )
}

export default index